"use client";
import React from "react";
import VideoPlayerCloudflare from "./../videoplayer/VideoPlayerCloudflare";

export const VideoItem = ({ videoType, url, caption }) => {
    const renderMedia = () => {
        switch (videoType) {
            case "link":
                return (
                    <video controls className="w-full rounded-lg">
                        <source src={url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                );
            case "youtube":
                return (
                    <iframe
                        src={`${url}`}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="w-full h-[94%] rounded-lg"
                    />
                );
            case "cloudflare":
                return (
                    <>
                        <VideoPlayerCloudflare src={url} />

                    </>
                    // <iframe
                    //     src={`https://iframe.videodelivery.net/${url}`}
                    //     className="w-full h-full rounded-lg"
                    //     allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    //     allowFullScreen
                    // />
                );
            default:
                return null;

        }
    };

    return (
        <div className="bg-gray-100 rounded-lg p-2 mr-2">
            {renderMedia()}
            <span className=" w-full px-3 rounded-md text-sm text-center focus:outline-none focus:ring-2 focus:ring-rose-500 mb-2">{caption}</span>
           
        </div>
    );
};